import { SignInButton, UserButton } from '@clerk/react';
import { useSession } from './use-session.js';

export function SessionStatus() {
  const session = useSession();

  if (session.status === 'carregando') {
    return <span className="badge badge-ghost">Carregando…</span>;
  }

  if (session.status === 'anonimo') {
    return (
      <div className="flex items-center gap-2" aria-label="Área da conta">
        <span className="badge badge-ghost hidden sm:inline-flex">Acesso do lojista</span>
        <SignInButton mode="modal">
          <button className="btn btn-primary btn-sm" type="button">
            Entrar
          </button>
        </SignInButton>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3" aria-label="Conta conectada">
      <span className="badge badge-ghost hidden sm:inline-flex">Olá, {session.displayName}</span>
      <UserButton />
    </div>
  );
}
